import React from 'react';

import { DataContext } from '../DataProvider';
import Section from '../Section';

function SectionList() {
  const { courseProgress } = React.useContext(DataContext);
  let firstIncompleteFound = false;

  const courseSections = Object.entries(courseProgress)
    .sort((a, b) => {
      const indexA = parseInt(a[0].split('#')[0], 10);
      const indexB = parseInt(b[0].split('#')[0], 10);
      return indexA - indexB;
    })
    .map(([key, value]) => {
      const title = key.split('#')[1];
      const hasIncompleteLessons = value.some(
        (lesson) => lesson.status === 'INCOMPLETE'
      );
      const isOpen = hasIncompleteLessons && !firstIncompleteFound;
      if (isOpen) {
        firstIncompleteFound = true;
      }
      return (
        <Section
          key={key}
          sectionLookup={key}
          title={title}
          lessons={value}
          initialIsOpen={isOpen}
        />
      );
    });

  return <div>{courseSections}</div>;
}

export default SectionList;
